export const HOME = { label: 'Home', url: '/' };

// Paths
export const CONFIG_LIST = '/payment-config/features/list';
export const CONFIG_ADD = '/payment-config/features/new';
export const TOGGLES_LIST = '/payment-config/toggles/list';
export const CHANNEL_HASHES_LIST = '/payment-config/channel-hashes/list';
export const CURRENCY_DETAILS = '/payment-config/currency-details';
export const ERROR_CONFIG = '/payment-config/error-config';

// Breadcrumbs
export const viewConfigs = [
  HOME,
  { label: 'Payment Configuration', url: CONFIG_LIST },
];
export const viewToggles = [HOME, { label: 'Toggles', url: TOGGLES_LIST }];

export const addConfig = [...viewConfigs, { label: 'New', url: CONFIG_ADD }];
export const editConfig = (id) => [
  ...viewConfigs,
  { label: 'Edit', url: `/payment-config/features/${id}` },
];

export const viewChannelHashes = [
  HOME,
  { label: 'Channel Hashes', url: CHANNEL_HASHES_LIST },
];

export const viewCurrencyDetails = [
  HOME,
  { label: 'Currency Details', url: CURRENCY_DETAILS },
];

export const viewErrorConfigs = [
  HOME,
  { label: 'Error Configs', url: ERROR_CONFIG },
];
